module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-like-89e6cd3cca5be780cb46f451984d3a79.svg";